import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

// ───────── 공지 ─────────
export async function getAdminNotices(locale = "ko-KR") {
  const qs = new URLSearchParams();
  if (locale) qs.set("locale", locale);

  const res = await authFetch(
    `${BACKEND_URL}/admin/notices${qs.toString() ? `?${qs.toString()}` : ""}`,
    { method: "GET" },
    { refreshUrlIncludes: "auth/refresh" },
  );
  return await res.json().catch(() => null);
}

export async function createAdminNotice(payload) {
  const res = await authFetch(
    `${BACKEND_URL}/admin/notices`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
    { refreshUrlIncludes: "auth/refresh" },
  );
  return await res.json().catch(() => null);
}

export async function updateAdminNotice(id, payload) {
  const res = await authFetch(
    `${BACKEND_URL}/admin/notices/${id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
    { refreshUrlIncludes: "auth/refresh" },
  );
  return await res.json().catch(() => null);
}

export async function deleteAdminNotice(id) {
  const res = await authFetch(
    `${BACKEND_URL}/admin/notices/${id}`,
    { method: "DELETE" },
    { refreshUrlIncludes: "auth/refresh" },
  );
  return await res.json().catch(() => null);
}

// ───────── 도움말(툴팁) ─────────
export async function getAdminHelpTooltips(locale = "ko-KR") {
  const qs = new URLSearchParams();
  if (locale) qs.set("locale", locale);

  const res = await authFetch(
    `${BACKEND_URL}/admin/help-tooltips${qs.toString() ? `?${qs.toString()}` : ""}`,
    { method: "GET" },
    { refreshUrlIncludes: "auth/refresh" },
  );
  return await res.json().catch(() => null);
}

// key 기준 업서트
export async function upsertAdminHelpTooltip(payload) {
  const res = await authFetch(
    `${BACKEND_URL}/admin/help-tooltips`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
    { refreshUrlIncludes: "auth/refresh" },
  );
  return await res.json().catch(() => null);
}

export async function deleteAdminHelpTooltip(key) {
  const res = await authFetch(
    `${BACKEND_URL}/admin/help-tooltips/${encodeURIComponent(key)}`,
    { method: "DELETE" },
    { refreshUrlIncludes: "auth/refresh" },
  );
  return await res.json().catch(() => null);
}
